import React from 'react';
import TableRow from './TableRow';
import { useAppSelector } from '../../../redux/store';
import TableRowIsHeader from './TableRowIsHeader';
import { IModal } from '../../Editor/IEditor';

interface TableContentProps {
  modal: IModal;
  setModal: React.Dispatch<React.SetStateAction<IModal>>;
}

const TableContent = ({ modal, setModal }: TableContentProps) => {
  const tableRows = useAppSelector((store) => store.app.tableRows);

  return (
    <tbody>
      {tableRows.map((row, index) => {
        return row.isHeader ? (
          <TableRowIsHeader key={index.toString()} row={row} modal={modal} setModal={setModal} />
        ) : (
          <TableRow key={index.toString()} row={row} />
        );
      })}
    </tbody>
  );
};

export default TableContent;
